import { useModuleContext } from "./ModuleContext"
import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"

/**
 * for use where UI actions and state updates are needed simultaneously
 * @returns {}
 */
export const useEditorActions = (firebase) => {
  const { dispatch, moduleUI, moduleState, moduleId } = useModuleContext()
  const { setIsComponentSidebarOpen, currentSlideIndex, currentSectionIndex, currentComponentIndex } = moduleUI

  const [isSaving, setIsSaving] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const addComponent = (componentData) => {
    // Add component to state
    dispatch({
      type: "INSERT_COMPONENT_AFTER_POSITION",
      slideIndex: currentSlideIndex,
      sectionIndex: currentSectionIndex,
      componentIndex: currentComponentIndex,
      payload: componentData,
    })

    // Update UI
    setIsComponentSidebarOpen(false)
  }

  const updateComponent = (componentData, coordinates) => {
    const { slideIndex, componentIndex, sectionIndex } = coordinates

    dispatch({
      type: "UPDATE_COMPONENT",
      slideIndex: slideIndex,
      componentIndex: componentIndex,
      sectionIndex: sectionIndex,
      payload: componentData,
    })

    setIsComponentSidebarOpen(false)
  }

  // shouldnt be here
  // const recordResponse = (response, coordinates) => {
  //   const { slideIndex, componentIndex, sectionIndex } = coordinates;

  //   dispatch({
  //     type: "RECORD_RESPONSE",
  //     slideIndex,
  //     componentIndex,
  //     sectionIndex,
  //     payload: response
  //   });
  // };

  const addComponentToEnd = (componentData, coordinates) => {
    const { lastSlideIndex, sectionIndex = 0 } = coordinates

    dispatch({
      type: "PUSH_COMPONENT_TO_SLIDE_END",
      slideIndex: lastSlideIndex,
      sectionIndex,
      payload: componentData,
    })

    setIsComponentSidebarOpen(false)
  }

  const deleteComponent = (coordinates) => {
    const { slideIndex, componentIndex, sectionIndex } = coordinates

    dispatch({
      type: "DELETE_COMPONENT",
      slideIndex,
      componentIndex,
      sectionIndex,
    })
  }

  /**
   * @description Create a new module in SQL database modules table
   * @returns {Promise} res
   */
  const createNewModule = async ({ accessType, isWingspansAdmin = false }) => {
    setIsSaving(true)
    let res
    try {
      res = await firebase.createModule({
        moduleJson: moduleState,
        accessType: accessType,
        isWingspansAdmin: isWingspansAdmin,
      })
      dispatch({
        type: "RESET_MODULE",
      })
    } catch (error) {
      console.error("Error saving new module", error)
    } finally {
      setIsSaving(false)
    }
    return res
  }

  /**
   * @description Update module in SQL database modules table
   * @returns
   * @returns {Promise} res
   */
  const saveUpdatedModule = async ({ accessType, isWingspansAdmin = false }) => {
    setIsSaving(true)
    let res
    try {
      res = await firebase.updateModuleById({
        moduleJson: moduleState,
        moduleId: moduleId,
        // isStockModule: isStockModule,
        accessType: accessType,
        isWingspansAdmin: isWingspansAdmin,
      })
    } catch (error) {
      console.error("Error saving updating module", error)
    } finally {
      setIsSaving(false)
    }
    return res
  }

  const deleteModule = async () => {
    if (!moduleId) {
      console.error("Module ID is required for deletion")
      return
    }
    if (isDeleting) {
      console.warn("Deletion already in progress")
      return
    }
    if (typeof window !== "undefined") {
      const confirmDelete = window.confirm("Are you sure you want to delete this module?")
      if (!confirmDelete) {
        return
      }
    }

    setIsDeleting(true)
    try {
      await firebase.deleteModuleById(moduleId)
      setIsDeleting(false)
      navigate(-1)
    } catch (error) {
      console.error("Error deleting module", error)
    } finally {
      setIsDeleting(false)
    }
  }

  return {
    addComponent,
    updateComponent,
    // recordResponse,
    addComponentToEnd,
    deleteComponent,
    deleteModule,
    createNewModule,
    saveUpdatedModule,
    isSaving,
    isDeleting,
  }
}
